import PartyRepository from "../repository/party-repository";

class PartyService
{
    #partyRepository;

    constructor() {
        this.#partyRepository = new PartyRepository();
    }

    async create(party) {
        try {
            const data = await this.#partyRepository.create(party);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async edit(party) {
        try {
            const data = await this.#partyRepository.edit(party);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async remove(party) {
        try {
            const data = await this.#partyRepository.remove({id: party.id});

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async findOne(id) {
        try {
            const data = await this.#partyRepository.getOneById(id);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async gridview(query) {
        try {
            const data = await this.#partyRepository.gridview(query);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async findAll() {
        try {
            const data = await this.#partyRepository.getAll();

            return data;
        } catch (error) {
            console.error(error);
        }
    }
}

export default PartyService;
